module.exports = __webpack_public_path__ + "img/20190724.aeaaf76e.png";